import React from 'react'
import { path } from 'ramda'
import PropTypes from 'prop-types'

import { Card } from '@telus-uds/components-web'
import PaymentBreakdownSection from './PaymentBreakdownSection/PaymentBreakdownSection'
import DueTodaySection from './DueTodaySection'
import HSMonthlyBill from './HSMonthlyBill'
import MobilityMonthlyBill from './MobilityMonthlyBill'
import { CardContainer } from './styles'
import { isBYODCart } from './utils'

const PriceSummary = ({ cart, dataTestId, isAuthenticated, TopActions, BottomActions }) => {
  const totalPrices = path(['root', 'totalPrices'], cart)

  const renderHSMonthlyBillSection = (totalPrice) => (
    <HSMonthlyBill
      totalPrice={totalPrice}
      isAuthenticated={isAuthenticated}
      cart={cart}
      dataTestId={dataTestId}
    />
  )

  const renderMobilityMonthlyBillSection = (totalPrice) => (
    <MobilityMonthlyBill
      totalPrice={totalPrice}
      isAuthenticated={isAuthenticated}
      dataTestId={dataTestId}
      isBYODCart={isBYODCart(cart)}
      cart={cart}
    />
  )

  return (
    <div data-testid={`${dataTestId}-price-summary-container`}>
      <CardContainer>
        <Card
          variant={{ padding: 'custom' }}
          tokens={{
            paddingBottom: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }}
          footer={
            <PaymentBreakdownSection
              totalPrices={totalPrices}
              isAuthenticated={isAuthenticated}
              renderHSMonthlyBill={renderHSMonthlyBillSection}
              renderMobilityMonthlyBill={renderMobilityMonthlyBillSection}
              dataTestId={dataTestId}
              cart={cart}
              Actions={BottomActions}
            />
          }
          footerPadding={{
            paddingBottom: 8,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }}
        >
          <DueTodaySection dataTestId={dataTestId} cart={cart} Actions={TopActions} />
        </Card>
      </CardContainer>
    </div>
  )
}

PriceSummary.propTypes = {
  cart: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  TopActions: PropTypes.node,
  BottomActions: PropTypes.node
}

PriceSummary.defaultProps = {
  TopActions: undefined,
  BottomActions: undefined
}

export default PriceSummary
